import { ResponsiveLine } from '@nivo/line';
import { linearGradientDef } from '@nivo/core';
import styled from 'styled-components';
import { isset } from '../../../helpers';

const LegendSymbolLine = ({
    id,
    x,
    y,
    size,
    fill,
    borderWidth,
    borderColor,
}) => {
    if (id === 'huidige periode') {
        return (
            <rect
                x={x}
                y={y}
                width={size}
                height={size}
                stroke="none"
                fill={fill}
                style={{ pointerEvents: 'none' }}
            />
        );
    }
    return (
        <line
            x1={x}
            y1={y + size / 2 - 1}
            x2={x + size}
            y2={y + size / 2 - 1}
            strokeWidth={2}
            stroke={fill}
            style={{ pointerEvents: 'none' }}
        />
    );
};

const TooltipContainer = styled.div`
    background: #fff;
    padding: 2px 8px;
    box-shadow: 1px 2px 6px 2px #888888;
`;
const Tooltip = ({ point }) => {
    const { data, serieColor } = point;
    const { xFormatted, y, originalY } = data;
    const yVal = 1 * (isset(originalY) ? originalY : y);
    return (
        <TooltipContainer>
            {xFormatted}{' '}
            <strong style={{ color: serieColor }}>
                {Math.round(yVal * 100) / 100}
            </strong>
        </TooltipContainer>
    );
};

const SeriesColorSymbol = styled.div`
    width: 12px;
    height: 12px;
    background-color: ${({ color }) => color};
`;
const SliceTooltip = ({ slice }) => {
    const { points } = slice;
    return (
        <TooltipContainer>
            {points.length && points[0].data.x}{' '}
            <table>
                <tbody>
                    {points.map((point) => {
                        const { data, serieColor, serieId, id } = point;
                        const { y, originalY } = data;
                        const yVal = 1 * (isset(originalY) ? originalY : y);

                        return (
                            <tr key={id}>
                                <td>
                                    <SeriesColorSymbol color={serieColor} />
                                </td>
                                <td>{serieId} </td>
                                <td style={{ textAlign: 'right' }}>
                                    {yVal.toFixed(2)}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </TooltipContainer>
    );
};

const MainContainer = styled.div`
    width: 100%;
    height: 100%;
    position: relative;
    padding-top: ${({ hasTitle }) => (hasTitle ? 16 : 4)}px;
`;
const Title = styled.div`
    position: absolute;
    top: 0px;
    left: 40px;
    font-weight: bold;
`;

// make sure parent container have a defined height when using
// responsive component, otherwise height will be 0 and
// no chart will be rendered.
const ResponsiveLineChart = ({
    data = [],
    xLabel,
    yLabel,
    xScaleMin = 'auto',
    xScaleMax,
    yScaleMin = 0,
    enableArea = true,
    title,
    chartStyle = 'line',
}) => {
    let colors = data.map((d) => d.color).filter((d) => d);
    if (colors.length < 1) {
        colors = { scheme: 'category10' };
    }

    const pointStyle = chartStyle === 'point';

    return (
        <MainContainer hasTitle={title}>
            {title && <Title>{title}</Title>}
            <ResponsiveLine
                data={data}
                colors={colors}
                margin={{
                    top: 20,
                    right: 40,
                    bottom: 40,
                    left: 50,
                }}
                xScale={{
                    // type: 'point',
                    type: 'linear',
                    min: xScaleMin,
                    max: xScaleMax,
                }}
                xFormat=">-.2f"
                yScale={{
                    type: 'linear',
                    min: yScaleMin,
                    max: 'auto',
                    stacked: false,
                    reverse: false,
                }}
                // yFormat=" >-.2f"
                axisTop={null}
                axisRight={null}
                axisBottom={{
                    legend: xLabel,
                    legendOffset: 32,
                    legendPosition: 'middle',
                }}
                axisLeft={{
                    orient: 'left',
                    tickSize: 5,
                    tickPadding: 5,
                    tickRotation: 0,
                    legend: yLabel,
                    legendOffset: -45,
                    legendPosition: 'middle',
                }}
                lineWidth={pointStyle ? 0 : 1}
                pointSize={pointStyle ? 3 : 0}
                // pointColor={{ theme: 'background' }}
                // pointBorderWidth={2}
                // pointBorderColor={{ from: 'serieColor' }}
                pointLabelYOffset={-12}
                useMesh={true}
                legends={[
                    {
                        anchor: 'top',
                        direction: 'row',
                        justify: false,
                        // translateX: 100,
                        translateY: -20,
                        itemsSpacing: 0,
                        itemDirection: 'left-to-right',
                        itemWidth: 130,
                        itemHeight: 20,
                        itemOpacity: 1,
                        symbolSize: 12,
                        symbolShape: LegendSymbolLine,
                        symbolBorderColor: 'rgba(0, 0, 0, .5)',
                        // effects: [
                        //     {
                        //         on: 'hover',
                        //         style: {
                        //             itemBackground: 'rgba(0, 0, 0, .03)',
                        //             itemOpacity: 1,
                        //         },
                        //     },
                        // ],
                    },
                ]}
                tooltip={Tooltip}
                enableSlices={data.length > 1 && !pointStyle ? 'x' : false}
                sliceTooltip={SliceTooltip}
                defs={[
                    linearGradientDef('gradientA', [
                        { offset: 0, color: 'inherit' },
                        { offset: 100, color: 'inherit', opacity: 0 },
                    ]),
                ]}
                enableArea={enableArea}
                fill={[{ match: '*', id: 'gradientA' }]}
                areaBaselineValue={yScaleMin}
                layers={[
                    'grid',
                    'markers',
                    'axes',
                    'areas',
                    'crosshair',
                    'lines',
                    'points',
                    'slices',
                    'mesh',
                    'legends',
                ]}
            />
        </MainContainer>
    );
};

export default ResponsiveLineChart;
